export default {"src":"/_next/static/media/yoyow.d10b9cfc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};